/* eslint-disable camelcase */

export default (api) => {

    function getImportAsnBatches(query) {
      return api.get(`/_svc/slapi-v1/sku-unique/batches`, query);
    }

    function getStockAsnBatches(query) {
      return api.get(`/_svc/slapi-v1/offer-stock/batches`, query);
    }

    function importPSkuUnique(file) {
      return api.post(`/_svc/slapi-v1/sku-unique/import`, file);
    }

    function getImportLines(query) {
      return api.get(`/_svc/slapi-v1/sku-unique/batch/lines${query}`);
    }

    function getStockLines(query) {
      return api.get(`/_svc/slapi-v1/offer-stock/batch/lines${query}`);
    }

    function exportStock() {
        return api.get(`/_svc/slapi-v1/reports/export/offer-stock`);
    }

    function importStock(file) {
      return api.post(`/_svc/slapi-v1/offer-stock/import`, file);
    }

    return {
        getImportAsnBatches,
        importPSkuUnique,
        getImportLines,
        getStockAsnBatches,
        getStockLines,
        exportStock,
        importStock
    };
};



// WEBPACK FOOTER //
// ./src/services/ImportService.js